import { generatePath } from 'react-router';
import { joinPath, ExtractPathParams } from '@/libs/react-router';
import { RegistryAlias } from '@/api/domains/registers.types';

const ROOT_PATH = '/registers';
const REFERENCE_PRICE_REGISTRY_VIEW_PATH = joinPath(ROOT_PATH, 'reference-price/:alias');
const REIMBURSEMENT_REGISTRY_VIEW_PATH = joinPath(ROOT_PATH, 'reimbursement/:alias');
const FIELD_MATCHING_PATH = joinPath(ROOT_PATH, 'fields');
const BINDING_PATH = joinPath(ROOT_PATH, ':alias/binding');
const IMPORT_LOG_PATH = joinPath(ROOT_PATH, ':alias/import-log');
const IMPORT_LOG_BASE_INFO_PATH = joinPath(IMPORT_LOG_PATH, 'info');
const IMPORT_LOG_ERRORS_PATH = joinPath(IMPORT_LOG_PATH, 'errors');

export type ReferencePriceRegistryViewPathParams = Omit<
  ExtractPathParams<typeof REFERENCE_PRICE_REGISTRY_VIEW_PATH>,
  'alias'
> & {
  alias: RegistryAlias;
};
export type ReimbursementRegistryViewPathParams = Omit<
  ExtractPathParams<typeof REIMBURSEMENT_REGISTRY_VIEW_PATH>,
  'alias'
> & {
  alias: RegistryAlias;
};
export type RegistryImportLogBasePathParams = Omit<ExtractPathParams<typeof IMPORT_LOG_BASE_INFO_PATH>, 'alias'> & {
  alias: RegistryAlias;
};
export type RegistryImportLogErrorPathParams = ExtractPathParams<typeof IMPORT_LOG_ERRORS_PATH>;
export type RegistryRegistryBindingPathParams = Omit<ExtractPathParams<typeof BINDING_PATH>, 'alias'> & {
  alias: RegistryAlias;
};

export const RegistersPaths = {
  ROOT_PATH,
  FIELD_MATCHING_PATH,
  IMPORT_LOG_PATH,

  REFERENCE_PRICE_REGISTRY_VIEW_PATH,
  generateReferencePriceRegistryViewPath: <TParams extends ReferencePriceRegistryViewPathParams>(params: TParams) =>
    generatePath(REFERENCE_PRICE_REGISTRY_VIEW_PATH, params),

  REIMBURSEMENT_REGISTRY_VIEW_PATH,
  generateReimbursementRegistryViewPath: <TParams extends ReimbursementRegistryViewPathParams>(params: TParams) =>
    generatePath(REIMBURSEMENT_REGISTRY_VIEW_PATH, params),

  IMPORT_LOG_BASE_INFO_PATH,
  generateImportLogBasePath: <TParams extends RegistryImportLogBasePathParams>(params: TParams) =>
    generatePath(IMPORT_LOG_BASE_INFO_PATH, params),

  IMPORT_LOG_ERRORS_PATH,
  generateImportLogErrorPath: <TParams extends RegistryImportLogErrorPathParams>(params: TParams) =>
    generatePath(IMPORT_LOG_ERRORS_PATH, params),

  BINDING_PATH,
  generateRegistryBindingPath: <TParams extends RegistryRegistryBindingPathParams>(params: TParams) =>
    generatePath(BINDING_PATH, params),
} as const;
